import { reactive, ref, computed, onMounted, watch, onBeforeMount } from '@vue/composition-api'
import store from '@/store'
import * as apiPrecedent from '@/api/precedent'
import * as apiSearchCondition from '@/api/search-condition'
import * as _ from 'lodash'
import { Document } from '@/logic/document/Document'
import * as validation from '@/util/validation'
import * as common from '@/util/common'

export const DocumentSearch = (props, context) => {
  const {documentLogic, updatePrecedentData} = Document(props, context)
  const router = context.root.$router

  onMounted(() => {
    store.dispatch('precedent/setTab', 1) // 1：検索タブ、2：目次タブ
    logic.init()
    documentLogic.init()

    // 月・日付リストの生成
    const monthArray = [{value: 0, name: '選択'}]
    const dayArray = [{value: 0, name: '選択'}]
    for (let i = 1; i <= 12; i++) {
      monthArray.push({value: i, name: i})
    }
    for (let i = 1; i <= 31; i++) {
      dayArray.push({value: i, name: i})
    }
    formData.date1.month = monthArray
    formData.date2.month = monthArray
    formData.date1.day = dayArray
    formData.date2.day = dayArray

    // 年号リストの作成
    const era = [
      {value: 0, name: '選択'},
      {value: 1, name: '令和'},
      {value: 2, name: '平成'},
      {value: 3, name: '昭和'},
      {value: 4, name: '大正'},
      {value: 5, name: '明治'}
    ]
    formData.date1.era = era
    formData.date2.era = era
  })

  const formData = reactive({
    // 検索分類
    selectedType: 0, // 0:すべて、1:先例、2:判例
    types: [
      {value: 0, name: 'すべて'},
      {value: 1, name: '先例'},
      {value: 2, name: '判例'}
    ],
    typesGroup: computed(() => {
      const groupData = _.groupBy(documentLogic.data.bookTypes, 'value3')
      return _.mapValues(groupData, group => _.map(group, 'code'))
    }),
    // キーワード
    keyword: '',
    keywordOption: true,
    keywordType: 1,

    // 日付
    date1: {
      era: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedEra: 0,
      year: [{value: 0, name: '選択'}],
      selectedYear: 0,
      month: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedMonth: 0,
      day: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedDay: 0
    },
    date2: {
      era: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedEra: 0,
      year: [{value: 0, name: '選択'}],
      selectedYear: 0,
      month: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedMonth: 0,
      day: [{value: 0, name: '選択'}], // 全体の生成はonMountedのタイミングで行う
      selectedDay: 0
    },
    // 日付期間
    restrictionList: [
      {value: 0, name: '日指定'},
      {value: 1, name: '期間指定'},
      {value: 2, name: '指定日以降'},
      {value: 3, name: '指定日以前'}
    ],
    selectedRestriction: 0,

    // 発翰番号
    selectedHakkan: 0,
    hakkan: computed(() => {
      const lists = documentLogic.data.hakkan.map((item) => {
        return { value: Number(item.code), name: item.value2}
      })
      // codeが0のデータは除く
      const filteredList = _.filter(lists, item => item.value !== 0)

      return [{value: 0, name: '選択なし'}, ...filteredList]
    }),
    hakkanNum1: '',
    hakkanNum2: '',
    hakkanNum3: '',

    // 裁判所
    saibansyoName: '',

    // 事件番号
    selectedJiken: 0,
    jiken: [
      { value: 0, name: '選択なし'},
      { value: 1, name: '明治'},
      { value: 2, name: '大正'},
      { value: 3, name: '昭和'},
      { value: 4, name: '平成'},
      { value: 5, name: '令和'}
    ],
    jikenNum1: '',
    jikenNum2: '',
    jikenNum3: '',

    // 出典
    selectedSyuttenn: 0,
    syuttenn: computed(() => {
      const lists = documentLogic.data.syuttenn.map((item) => {
        return { value: Number(item.code), name: item.value2 + '-' + item.value3, shortName: item.value2}
      })

      return [{value: 0, name: '選択なし'}, ...lists]
    }),
    syuttennText: '',

    // ページネーション・設定変更用にAPIに送るパラメータを裏で保持
    sendFormParams: {}
  })

  const formError = reactive({
    keyword: '',
    date1: '',
    date2: '',
    hakkan: '',
    jiken: '',
    syuttenn: ''
  })

  const settings = reactive({
    // 1ページ当たりの表示件数
    perPage: computed(() => {
      return store.state.precedent.searchSetting.per_page
    }),
    // 並び順
    searchOrder: computed(() => {
      return store.state.precedent.searchSetting.searchOrder
    }),
    // 順序
    ascending: computed(() => {
      return store.state.precedent.searchSetting.ascending
    })
  })

  // ページ固有のロジック
  const logic = reactive({
    // 検索条件復元用
    recoveryData: {},

    // 初期表示
    init: () => {
      logic.recoveryData = {}
      documentLogic.getBooks()

      // 詳細URLでのアクセス
      if (props.detailId !== 0) {
        // 処理はURL監視の方で対応

      // 検索トップへのアクセス
      } else {
        documentLogic.state.isFirst = false
        const otherScreenSearchParams = store.getters['search/getPrecedentSearchParam']

        // 検索条件一覧からの遷移
        if (Object.keys(otherScreenSearchParams).length > 0) {
          logic.recoveryData = otherScreenSearchParams

          // APIを挟むとnumber型への型変換が起きる場合があるのでstring型へ戻す
          const convertKeys = ['search_text', 'hakkan1', 'hakkan2', 'hakkan3', 'case_gou', 'case_kigou', 'source_keyword']
          const convertToString = (obj, keys) => {
            for (const key of keys) {
              if (typeof obj[key] === 'number') {
                obj[key] = String(obj[key])
              }
            }
          }
          convertToString(logic.recoveryData, convertKeys)

          // searchの方のstoreをクリア
          store.dispatch('search/resetPrecedent')

        // storeに検索履歴がある場合
        } else if (Object.keys(store.state.precedent.searchParams).length > 0) {
          logic.recoveryData = store.state.precedent.searchParams
        }

        // マスターデータ取得後に復元
        if (Object.keys(logic.recoveryData).length > 0) {
          store.dispatch('precedent/setBookRevisionId', logic.recoveryData.book_revision_id)
          if (logic.recoveryData.book_id !== 0) {
            store.dispatch('precedent/setBookId', logic.recoveryData.book_id)
          }
          store.dispatch('precedent/clearTheme')
          store.dispatch('precedent/clearDetail')
        }
        documentLogic.state.isRevisionFixed = true
      }

      documentLogic.getMasterData()
    },

    // 検索結果データ取得
    updateSearchResultArea: (type = 'pagenate') => {
      logic.recoveryData = {}
      let formParams = {}
      if (type === 'submit') {
        formParams = logic.getFormParam()
      } else if (type === 'pagenate') {
        formParams = formData.sendFormParams
      }

      const params = {
        ...formParams,

        book_revision_id: documentLogic.state.bookRevisionId, // 書籍リビジョンID
        per_page: settings.perPage, // 取得件数
        search_order: settings.searchOrder, // 並び順
        ascending: settings.ascending, // 順序

        start: (pagenation.currentPage - 1) * settings.perPage, // 取得開始位置
        is_paginate: pagenation.isPaginate ? 1 : 0 // ページネートフラグ 1:ページネータからの呼び出し　それ以外:ページネート外からの呼び出し
      }
      documentLogic.state.isListLoading = true
      apiPrecedent.search(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            // タブ情報の更新
            store.dispatch('precedent/setTab', 1) // 1：検索タブ、2：目次タブ
            
            // storeに検索条件を保存する際、bookIdを補完
            const currentBook = _.find(documentLogic.state.books, { book_revision_id: params.book_revision_id})
            if (currentBook) {
              params.book_id = currentBook.book_id
            } else {
              params.book_id = 0
            }
            // storeに検索条件を保存
            store.dispatch('precedent/setSearchParams', params)

            // 裏にも保存
            formData.sendFormParams = formParams

            // 書籍の更新があった場合、storeの値を更新してトップに戻る
            // 関連要旨・参照取得処理の場合は処理しない
            if (String(params.book_revision_id) !== String(data.book_revision_id)) {
              // storeの値を更新
              store.dispatch('precedent/setBookRevisionId', data.book_revision_id)
              store.dispatch('precedent/clearTheme')
              store.dispatch('precedent/clearDetail')

              // 更新しますモーダルを表示して情報を復元
              const routerFunc = () => {
                store.dispatch('common/hideNotice')
                router.push({name: 'DocumentTop'})
              }
              const payload = {
                title: 'エラー',
                text: '資料が更新されました。情報を再取得します。',
                button1: {
                  action: routerFunc
                },
                buttonClose: {
                  action: routerFunc
                }
              }
              store.dispatch('common/showNotice', payload)
              return []
            }

            // 表示用にデータを加工
            const updatedResponse = updatePrecedentData(data.list, 'search')

            documentLogic.data.list = updatedResponse

          } else {
            // エラー処理
            const payload = {
              title: 'エラー',
              text: data.error_message
            }
            store.dispatch('common/showNotice', payload)
            store.dispatch('precedent/clearAll')
            return []
          }
        })
        .finally(() => {
          documentLogic.state.isListLoading = false
        })
      apiPrecedent.searchCount(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            // 全データ件数
            pagenation.totalItems = data.count

            // ページネーション表示フラグ（2ページ以上の場合に表示）
            pagenation.isPaginationShown = (pagenation.totalItems > settings.perPage)
          }
        })
    },

    validation: () => {
      // 入力エラーチェック処理
      let isError = false
      resetForm.error()

      // キーワード
      if (!validation.checkMaxLength(formData.keyword, 50)) {
        formError.keyword = '全角50文字以内で入力してください。'
        isError = true
      }

      // 先例・判例
      if (formData.selectedType !== 0) {
        // 日付
        // 期間指定の場合
        if (formData.selectedRestriction === 1) {
          // 元号・年・月・日のいずれかが抜けていないか確認
          if (formData.date1.selectedEra === 0 || formData.date1.selectedYear === 0 || formData.date1.selectedMonth === 0 || formData.date1.selectedDay === 0) {
            formError.date1 = '元号・年・月・日をすべて入力してください。'
            isError = true
          }
          if (formData.date2.selectedEra === 0 || formData.date2.selectedYear === 0 || formData.date2.selectedMonth === 0 || formData.date2.selectedDay === 0) {
            formError.date2 = '元号・年・月・日をすべて入力してください。'
            isError = true
          }

          // 全て埋まっている場合
          // 開始年月日（から）＜ 終了年月日（まで）のチェックをする
          if (formError.date1 === '' && formError.date2 === '') {
            const era1 = _.find(formData.date1.era, { value: formData.date1.selectedEra}).name
            const era2 = _.find(formData.date2.era, { value: formData.date2.selectedEra}).name
            const gregorianStartYear = common.convertElaYearToGregorianYear(era1, formData.date1.selectedYear)
            const gregorianEndYear = common.convertElaYearToGregorianYear(era2, formData.date2.selectedYear)
            const startValue = gregorianStartYear * 10000 + formData.date1.selectedMonth * 100 + formData.date1.selectedDay
            const endValue = gregorianEndYear * 10000 + formData.date2.selectedMonth * 100 + formData.date2.selectedDay

            if (startValue > endValue) {
              formError.date1 = '開始日は終了日よりも過去を入力してください。'
              isError = true
            }
          }

        // 期間指定ではない場合
        } else {
          // 日付指定はデフォルトなので、全部未入力を許容
          if (formData.selectedRestriction === 0) {
            // 元号・年・月・日のいずれかが入力されている
            if (formData.date1.selectedEra !== 0 || formData.date1.selectedYear !== 0 || formData.date1.selectedMonth !== 0 || formData.date1.selectedDay !== 0) {
              // 元号・年・月・日のいずれかが入力されている
              if (formData.date1.selectedEra === 0 || formData.date1.selectedYear === 0 || formData.date1.selectedMonth === 0 || formData.date1.selectedDay === 0) {
                formError.date1 = '元号・年・月・日をすべて入力してください。'
                isError = true
              }
            }
          } else {
            if (formData.date1.selectedEra === 0 || formData.date1.selectedYear === 0 || formData.date1.selectedMonth === 0 || formData.date1.selectedDay === 0) {
              formError.date1 = '元号・年・月・日をすべて入力してください。'
              isError = true
            }
          }
        }
      }

      // 先例
      if (formData.selectedType === 1) {
        // 発翰番号
        /*
        if (formData.hakkanNum1) {
          const value = common.convertAsciiZ2H(formData.hakkanNum1)
          formData.hakkanNum1 = value
          if (!validation.checkHankakuNumber(value)) {
            formError.hakkan = '半角数字で入力してください。'
            isError = true
          }
        } */
        if (formData.hakkanNum2) {
          const value = common.convertAsciiZ2H(formData.hakkanNum2)
          formData.hakkanNum2 = value
          if (!validation.checkHankakuNumber(value)) {
            formError.hakkan = '半角数字で入力してください。'
            isError = true
          }
        }
        if (formData.hakkanNum3) {
          const value = common.convertAsciiZ2H(formData.hakkanNum3)
          formData.hakkanNum3 = value
          if (!validation.checkHankakuNumber(value)) {
            formError.hakkan = '半角数字で入力してください。'
            isError = true
          }
        }

      // 判例
      } else if (formData.selectedType === 2) {
        // 事件番号
        // 第一項目
        if (formData.selectedJiken === 0 && formData.jikenNum1 === '') {
        } else if (formData.selectedJiken === 0 || formData.jikenNum1 === '') {
          formError.jiken = '年号と年数はセットで入力してください。'
          isError = true
        } else if (formData.jikenNum1) {
          const value = common.convertAsciiZ2H(formData.jikenNum1)
          formData.jikenNum1 = value
          if (!validation.checkHankakuNumber(value)) {
            formError.jiken = '年数は半角数字で入力してください。'
            isError = true
          }
        }

        // 第三項目
        if (formData.jikenNum3) {
          const value = common.convertAsciiZ2H(formData.jikenNum3)
          formData.jikenNum3 = value
          if (!validation.checkHankakuNumber(value)) {
            formError.hakkan += '号数は半角数字で入力してください。'
            isError = true
          }
        }

        // 出典
        if (!validation.checkMaxLength(formData.syuttennText, 50)) {
          formError.syuttenn = '全角50文字以内で入力してください。'
          isError = true
        }
      }

      return isError
    },

    // フォームに入力された値からAPIに送るためのパラメータを生成
    getFormParam: () => {
      const params = {}

      // 検索分類
      if (formData.selectedType === 1) {
        params.search_type = formData.typesGroup['先例']
      } else if (formData.selectedType === 2) {
        params.search_type = formData.typesGroup['判例']
      }

      // キーワード
      if (formData.keyword) params.search_text = formData.keyword
      if (formData.keywordOption) {
        params.is_fuzzy = 0
      } else {
        params.is_fuzzy = 1
      }

      if (formData.selectedType !== 0) {
        // 検索範囲
        params.search_range = Number(formData.keywordType)

        // 日付フォーマット用
        const formatDate = (date) => {
          const result = date.getFullYear() +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            ('0' + date.getDate()).slice(-2)

          return result
        }

        // 日付
        if (formData.date1.selectedEra !== 0 && formData.date1.selectedYear !== 0 && formData.date1.selectedMonth !== 0 && formData.date1.selectedDay !== 0) {
          // 日付セレクタ1の値を収集してフォーマット
          const startEra = _.find(formData.date1.era, { value: formData.date1.selectedEra}).name
          const gregorianStartYear = common.convertElaYearToGregorianYear(startEra, formData.date1.selectedYear)
          const startDate = new Date(gregorianStartYear, formData.date1.selectedMonth - 1, formData.date1.selectedDay)
          const formattedStartDate = formatDate(startDate)

          if (formData.selectedRestriction === 0) {
            params.date = formattedStartDate

          } else if (formData.selectedRestriction === 1) {
            // 日付セレクタ2の値を収集してフォーマット
            const endEra = _.find(formData.date2.era, { value: formData.date2.selectedEra}).name
            const gregorianEndYear = common.convertElaYearToGregorianYear(endEra, formData.date2.selectedYear)
            const endDate = new Date(gregorianEndYear, formData.date2.selectedMonth - 1, formData.date2.selectedDay)
            const formattedEndDate = formatDate(endDate)

            params.date_start = formattedStartDate
            params.date_end = formattedEndDate

          } else if (formData.selectedRestriction === 2) {
            params.date_start = formattedStartDate

          } else if (formData.selectedRestriction === 3) {
            params.date_end = formattedStartDate

          }
        }
      }

      // 判例の場合
      if (formData.selectedType === 2) {
        // 出典
        if (formData.selectedSyuttenn !== 0) {
          const syuttennData = _.find(documentLogic.data.syuttenn, { code: String(formData.selectedSyuttenn)})
          params.source = syuttennData.value2
        }
        if (formData.syuttennText) params.source_keyword = formData.syuttennText

        // 事件
        if (formData.selectedJiken !== 0) {
          const jikenData = _.find(formData.jiken, { value: formData.selectedJiken})
          params.case_year = jikenData.name + formData.jikenNum1
        } else {
          if (formData.jikenNum1) params.case_year = formData.jikenNum1
        }
        if (formData.jikenNum2) params.case_kigou = formData.jikenNum2
        if (formData.jikenNum3) params.case_gou = formData.jikenNum3

        // 裁判所
        if (formData.saibansyoName !== '') {
          params.court = formData.saibansyoName
        }
      // 先例の場合
      } else if (formData.selectedType === 1) {
        // 発翰
        if (formData.selectedHakkan !== 0) params.hakkan = formData.selectedHakkan
        if (formData.hakkanNum1) params.hakkan1 = formData.hakkanNum1
        if (formData.hakkanNum2) params.hakkan2 = formData.hakkanNum2
        if (formData.hakkanNum3) params.hakkan3 = formData.hakkanNum3
      }

      return params
    },

    // 検索履歴や検索条件保存画面から渡された情報や
    // storeに保存されている情報からフォームの入力欄に検索条件を復元
    setFormParam: (params) => {
      // 検索分類
      const typeData = logic.checkSelectedType(params.search_type)
      oparationSelectbox.changeType(typeData.typeNum)

      // キーワード
      if (params.search_text) formData.keyword = params.search_text
      if (params.is_fuzzy === 0) {
        formData.keywordOption = true
      } else {
        formData.keywordOption = false
      }

      // 検索範囲
      if (params.search_range) {
        formData.keywordType = params.search_range
      }

      // 日付
      // 日付データからセレクトボックスを選択する処理
      const setDateSelecbox = (date, type = 'date1') => {
        const stringDate = String(date)

        const dateText = stringDate.substring(0, 4) +
          '-' +
          stringDate.substring(4, 6) +
          '-' +
          stringDate.substring(6, 8)

        const dateData = common.convertToJapaneseEra(dateText, 'array')
        if (dateData.year === '元') dateData.year = 1

        if (type === 'date1') {
          const eraNum = _.find(formData.date1.era, { name: dateData.era}).value

          oparationSelectbox.changeEra1(eraNum, 'notReset')
          oparationSelectbox.changeYear1(dateData.year)
          oparationSelectbox.changeMonth1(dateData.month)
          oparationSelectbox.changeDay1(dateData.day)

        } else if (type === 'date2') {
          const eraNum = _.find(formData.date2.era, { name: dateData.era}).value

          oparationSelectbox.changeEra2(eraNum, 'notReset')
          oparationSelectbox.changeYear2(dateData.year)
          oparationSelectbox.changeMonth2(dateData.month)
          oparationSelectbox.changeDay2(dateData.day)
        }
      }

      // 日指定
      if (params.date) {
        oparationSelectbox.changeRestriction(0)
        setDateSelecbox(params.date, 'date1')

      // 期間指定
      } else if (params.date_start && params.date_end) {
        oparationSelectbox.changeRestriction(1)
        setDateSelecbox(params.date_start, 'date1')
        setDateSelecbox(params.date_end, 'date2')

      // 指定日以降
      } else if (params.date_start) {
        oparationSelectbox.changeRestriction(2)
        setDateSelecbox(params.date_start, 'date1')

      // 指定日以前
      } else if (params.date_end) {
        oparationSelectbox.changeRestriction(3)
        setDateSelecbox(params.date_end, 'date1')

      }

      // 判例の場合
      // 出典
      if (params.source) {
        const result = _.find(formData.syuttenn, { shortName: params.source})
        if (result) {
          oparationSelectbox.changeSyuttenn(result.value)
        }
      }
      if (params.source_keyword) formData.syuttennText = params.source_keyword

      // 事件
      if (params.case_year) {
        const era = params.case_year.replace(/\d+/g, '')
        const year = params.case_year.replace(/[^0-9]/g, '')
        const eraData = _.find(formData.jiken, { name: era})

        oparationSelectbox.changeJiken(eraData.value)
        formData.jikenNum1 = year
      }
      if (params.case_kigou) formData.jikenNum2 = params.case_kigou
      if (params.case_gou) formData.jikenNum3 = params.case_gou

      // 裁判所
      if (params.court) formData.saibansyoName = params.court

      // 先例の場合
      // 発翰
      if (params.hakkan) {
        oparationSelectbox.changeHakkan(params.hakkan)
      }
      if (params.hakkan1) formData.hakkanNum1 = params.hakkan1
      if (params.hakkan2) formData.hakkanNum2 = params.hakkan2
      if (params.hakkan3) formData.hakkanNum3 = params.hakkan3
    },

    saveSearch: () => {
      const formParams = formData.sendFormParams
      formParams.book_revision_id = documentLogic.state.bookRevisionId
      formParams.book_id = documentLogic.state.bookId

      const typeData = logic.checkSelectedType(formParams.search_type)
      const params = {
        title: formParams.search_text
          ? '資料検索（' + typeData.typeText + '）：' + formParams.search_text
          : '資料検索（' + typeData.typeText + '）：キーワードなし',
        key: 'pj',
        search: _.map(formParams, (value, key) => {
          return {
            key: key,
            value: value
          }
        })
      }

      apiSearchCondition.add(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            store.dispatch('common/showToast', { text: '検索条件を保存しました。' })
          }
        })
    },

    submitSettings: () => {
      // 設定モーダルを閉じる
      documentLogic.state.visibleSearchOrderSettings = false
      documentLogic.state.visibleSearchDisplaySettings = false

      // ページネーションをリセットして再検索
      pagenation.currentPage = 1
      logic.updateSearchResultArea()
    },

    submitForm: () => {
      // バリデーションチェック
      const isError = logic.validation()
      if (isError) return

      documentLogic.state.isShowDetail = false
      documentLogic.state.isShowResult = true

      pagenation.currentPage = 1
      pagenation.isPaginate = false
      logic.updateSearchResultArea('submit')
      documentLogic.state.isFilteredTheme = false

      // 詳細のURLだった場合、URLを変更
      if (router.currentRoute.name === 'PCDocumentSearchDetail') {
        router.push({name: 'PCDocumentSearch'})
      } else if (router.currentRoute.name === 'SPDocumentSearchDetail') {
        router.push({name: 'SPDocumentSearch'})
      }
    },

    // search_typeとmasterの値からselectedTypeを判定する // 0:すべて、1:先例、2:判例
    checkSelectedType: (typeArray) => {
      const senrei = _.filter(documentLogic.data.bookTypes, { value3: '先例' })
      const hanrei = _.filter(documentLogic.data.bookTypes, { value3: '判例' })
      const senreiArray = _.map(senrei, 'code')
      const hanreiArray = _.map(hanrei, 'code')

      let typeNum = 0
      let typeText = 'すべて'
      if (typeArray) {
        if (logic.arraysMatch(typeArray, senreiArray)) {
          typeNum = 1
          typeText = '先例'
        } else if (logic.arraysMatch(typeArray, hanreiArray)) {
          typeNum = 2
          typeText = '判例'
        }
      }
      const typeData = {
        typeNum,
        typeText
      }
      return typeData
    },

    // 配列が一致するか判定する
    arraysMatch: (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
        return false // 長さが異なる場合は一致しない
      }

      return arr1.every(function(element, index) {
        return element === arr2[index]
      })
    },

    /**
     * 裁判所選択を更新（裁判所選択ウィンドウから実行される）
     */
    updatSaibansyoName: (courtNames) => {
      formData.saibansyoName = courtNames
    },
    /**
     * 裁判所選択をクリア（指定をクリアボタン）
     */
    clearSaibansyoName: () => {
      formData.saibansyoName = ''
    }
  })

  const resetForm = reactive({
    reset: () => {
      oparationSelectbox.changeType(0)
      formData.keyword = ''
      formData.keywordOption = true
      formData.keywordType = 1
      formData.isCalendarStartOnly = false
      oparationSelectbox.changeEra1(0)
      oparationSelectbox.changeYear1(0)
      oparationSelectbox.changeMonth1(0)
      oparationSelectbox.changeDay1(0)
      oparationSelectbox.changeEra2(0)
      oparationSelectbox.changeYear2(0)
      oparationSelectbox.changeMonth2(0)
      oparationSelectbox.changeDay2(0)
      oparationSelectbox.changeRestriction(0)
      oparationSelectbox.changeHakkan(0)
      formData.hakkanNum1 = ''
      formData.hakkanNum2 = ''
      formData.hakkanNum3 = ''
      formData.saibansyoName = ''
      oparationSelectbox.changeJiken(0)
      formData.jikenNum1 = ''
      formData.jikenNum2 = ''
      formData.jikenNum3 = ''
      oparationSelectbox.changeSyuttenn(0)
      formData.syuttennText = ''

      // エラー表示もリセット
      resetForm.error()

      // ページネーション・設定変更用にAPIに送るパラメータはクリアしない
      // formData.sendFormParams = {}

      // store検索条件もクリア
      store.dispatch('precedent/setSearchParams', {})
    },
    error: () => {
      formError.keyword = ''
      formError.date1 = ''
      formError.date2 = ''
      formError.hakkan = ''
      formError.jiken = ''
      formError.syuttenn = ''
    }
  })

  const oparationSelectbox = reactive({
    // 検索分類の変更
    changeType: (selected) => {
      formData.selectedType = Number(selected)
    },
    // 発翰番号の変更
    changeHakkan: (selected) => {
      formData.selectedHakkan = selected
    },
    // 事件番号の変更
    changeJiken: (selected) => {
      formData.selectedJiken = selected
    },
    // 出典の変更
    changeSyuttenn: (selected) => {
      formData.selectedSyuttenn = selected
    },
    // 期間プルダウン系
    // 年号の変更
    changeEra1: (selected, type = 'default') => {
      formData.date1.selectedEra = selected

      let lastYear = 0
      const eraName = _.find(formData.date1.era, {value: formData.date1.selectedEra})
      if (eraName) {
        lastYear = common.getLastYearOfEra(eraName.name)
      }

      const list = [{value: 0, name: '選択'}]

      for (let i = 1; i <= lastYear; i++) {
        if (i === 1) {
          list.push({value: i, name: '元'})
        } else {
          list.push({value: i, name: i})
        }
      }
      formData.date1.year = list

      // 選択された年号に選択済みの年がなければリセット
      if (type === 'default' && lastYear < formData.date1.selectedYear) {
        formData.date1.selectedYear = 0
      }
    },
    // 年の変更
    changeYear1: (selected) => {
      formData.date1.selectedYear = selected
    },
    // 月の変更
    changeMonth1: (selected) => {
      formData.date1.selectedMonth = selected
    },
    // 日付の変更
    changeDay1: (selected) => {
      formData.date1.selectedDay = selected
    },
    // 年号の変更
    changeEra2: (selected, type = 'default') => {
      formData.date2.selectedEra = selected

      let lastYear = 0
      const eraName = _.find(formData.date2.era, {value: formData.date2.selectedEra})
      if (eraName) {
        lastYear = common.getLastYearOfEra(eraName.name)
      }

      const list = [{value: 0, name: '選択'}]

      for (let i = 1; i <= lastYear; i++) {
        if (i === 1) {
          list.push({value: i, name: '元'})
        } else {
          list.push({value: i, name: i})
        }
      }
      formData.date2.year = list

      // 選択された年号に選択済みの年がなければリセット
      if (type === 'default' && lastYear < formData.date2.selectedYear) {
        formData.date2.selectedYear = 0
      }
    },
    // 年の変更
    changeYear2: (selected) => {
      formData.date2.selectedYear = selected
    },
    // 月の変更
    changeMonth2: (selected) => {
      formData.date2.selectedMonth = selected
    },
    // 日付の変更
    changeDay2: (selected) => {
      formData.date2.selectedDay = selected
    },
    // 期間指定の変更
    changeRestriction: (selected) => {
      formData.selectedRestriction = selected
    }
  })

  const pagenation = reactive({
    isPaginationShown: false, // ページネーション表示フラグ（2ページ以上の場合に表示）
    totalItems: 0, // 全データ件数
    isPaginate: false, // ページネートフラグ(初回検索のみfalse、以降ページ切り替え後はずっとtrue)

    // 現在のページ
    currentPage: computed({
      get: () => {
        let page = store.state.precedent.searchPage
        if (page < 1) {
          page = 1
        }
        return page
      },
      set: (value) => {
        store.dispatch('precedent/setPage', value)
      }
    }),
    /**
     * ページが変更された場合（ページネーションをクリックした場合）
     */
    onPageChanged: ({ currentPage, start }) => {
      // 新しいページの情報を設定
      pagenation.currentPage = currentPage
      // ページネートフラグは、ページ切り替えのためtrue
      pagenation.isPaginate = true

      // 検索結果一覧エリアを更新
      logic.updateSearchResultArea()
    }
  })

  const showForm = reactive({
    open: () => {
      documentLogic.state.isShowResult = false
      documentLogic.state.isShowDetail = false
    },
    // SP用
    list: () => {
      documentLogic.state.isShowResult = true
      documentLogic.state.isShowDetail = false
    }
  })

  // URLを監視する
  watch(() => props.detailId, (newVal, oldVal) => {
    if (newVal) {
      store.dispatch('precedent/setDetailId', newVal)

      _.each(documentLogic.data.list, (value, index) => {
        // 一覧のカレント付け替え
        if (value.id === newVal) {
          documentLogic.data.list[index].isCurrent = true
        } else if (value.id === oldVal) {
          documentLogic.data.list[index].isCurrent = false
        }

        // 関連要旨のカレント付け替え
        _.each(value.relatedItems, (relatedItem, index2) => {
          if (relatedItem.id === newVal) {
            documentLogic.data.list[index].relatedItems[index2].isCurrent = true
          } else if (relatedItem.id === oldVal) {
            documentLogic.data.list[index].relatedItems[index2].isCurrent = false
          }
        })
        // 参照のカレント付け替え
        _.each(value.referenceItems, (referenceItem, index3) => {
          if (referenceItem.id === newVal) {
            documentLogic.data.list[index].referenceItems[index3].isCurrent = true
          } else if (referenceItem.id === oldVal) {
            documentLogic.data.list[index].referenceItems[index3].isCurrent = false
          }
        })
      })

      documentLogic.getDetaiPage(newVal)
      documentLogic.state.isShowDetail = true
    }
  })

  // 書籍の切り替えを監視
  watch(() => documentLogic.state.isBookChanged, (newVal) => {
    if (newVal) {
      // フォームの情報をリセット
      resetForm.reset()
      resetForm.error()
      formData.sendFormParams = {}
      logic.recoveryData = {}

      documentLogic.state.isBookChanged = false
    }
  })

  // 書籍データの読み込みが完了し、詳細APIのレスポンスが帰ってきたら書籍セレクタを更新
  watch(() => (!documentLogic.state.isBooksLoading && !documentLogic.state.isFirst), (newVal) => {
    if (newVal) {
      documentLogic.changeBook()
    }
  })

  // マスター取得後に検索条件を復元
  watch(() => (!documentLogic.state.isMasterLoading), (newVal) => {
    if (newVal) {
      if (Object.keys(logic.recoveryData).length > 0) {
        // リカバリーデータは検索実行時と書籍変更時に削除
        logic.setFormParam(logic.recoveryData)
      }
    }
  })

  return {
    documentLogic,
    formData,
    formError,
    logic,
    resetForm,
    oparationSelectbox,
    pagenation,
    showForm,
    settings
  }
}
